import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';


import { HttpService } from '@services/http.service';
import { ContractDetail } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class ContractsFilterService extends HttpService {
    private contractsSubject = new BehaviorSubject<ContractDetail[]>([]);
    private contractSubject = new BehaviorSubject<ContractDetail | null>(null);
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { contracts: ContractDetail[]; contract: ContractDetail | null} = { contracts: [], contract: null };

    get contracts(): Observable<ContractDetail[]> {
        return this.contractsSubject.asObservable();
    }

    get contract(): Observable<ContractDetail | null> {
        return this.contractSubject.asObservable();
    }

    get loadingData(): Observable<boolean> {
        return this.isLoadingDataSubject.asObservable();
    }

    getNextService(ianaZone: string): void {
        this.loading(true);
        this.next([]);
        this.getNextFilter(ianaZone).subscribe(
            () => {
                this.contractSubject.next(this.dataStore.contract);
                this.loading(false);
            }
        );
    }
    private getNextFilter(ianaZone: string): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                const params = new HttpParams();
                this.dataStore.contract = null;
                this.get('customer/services/schedules/me', { app: 'member', version: 3 }, params).subscribe(
                    data => {
                        if (data != null) {
                            this.dataStore.contract = new ContractDetail().buildFromContract(data, ianaZone);
                        }
                        observable.next(true);
                    }, () => observable.next(false)
                );
            }
        );
    }

    private next(data: ContractDetail[]): void {
        this.contractsSubject.next(data);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
